import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getInfomateryDeatilsAction } from "../actions/dataConfig";
import { get } from "lodash";

export const useFetchInfomateryData = (lan = "en") => {
  const reduxInfomateryDetails = useSelector((state) =>
    get(state, "app.infomateryDetails", "")
  );
  const tenantId = useSelector((state) =>
    get(state, "app.preSignInState.tenantId", "")
  );

  const userId = useSelector((state) =>
    get(state, "app.preSignInData.userId", "")
  );
  const authToken = useSelector((state) =>
    get(state, "app.signInData.authToken", "")
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchInfoData = async () => {
      if (!reduxInfomateryDetails) {
        const params = { list: `${lan}.json` };
        try {
          await dispatch(
            getInfomateryDeatilsAction({
              tenantId,
              authToken,
              userId,
              params,
              showSpinner: false,
            })
          ).catch((err) => {
            console.log(err);
          });
        } catch (err) {
          console.log(err);
        }
      }
    };

    fetchInfoData();
  }, [reduxInfomateryDetails]);

  return reduxInfomateryDetails;
};
